export enum IMAGE_TYPE {
    GIF = "gif",
    JPEG = "jpeg",
    JPG = "jpg",
    PNG = "png",
    SVG = "svg",
    WEBP = "webp",
}